import { workspace } from '../../shared/api';
import { DrugAllergy, PatientDto } from '../../interfaces/patient';

export interface Icd {
  id: number;
  subcategory: string;
  description: string;
}

export const PatientService = {
  async getIcd(icd: string): Promise<Icd[]> {
    const params = {
      query: icd,
    };
    const { data } = await workspace.get('/prescricao/cid/busca', { params });
    return data;
  },
  async getIcdByMedicine(icd: string, medicineId: number): Promise<Icd[]> {
    const params = {
      query: icd,
      idMedicamento: medicineId,
    };
    const { data } = await workspace.get('/prescricao/cid/busca', { params });
    return data;
  },
  async getAllergy(allergy: string): Promise<DrugAllergy[]> {
    const params = {
      query: allergy,
    };
    const { data } = await workspace.get('/prescricao/alergia/busca', { params });
    return data.data;
  },
  async updatePatient(patient: PatientDto, prescriptionId: number): Promise<any> {
    const { data } = await workspace.put(`/paciente/${patient.idPaciente}?idPrescricao=${prescriptionId}`, patient);
    return data;
  },
};
